export default {
  // Base
  black: '#000000',
  white: '#ffffff',

  // Backgrounds
  cream: '#fafafa',
  warmWhite: '#ffffff',
  bgSubtle: '#f3f3f3',
  bgAlt: '#ebebeb',

  // Text
  dark: '#0a0a0a',
  textSecondary: '#6b6b6b',
  textTertiary: '#737373',
  textQuaternary: '#a0a0a0',

  // Dark surface
  dark2: '#141414',
  dark3: '#1c1c1c',
  darkCard: '#0a0a0a',

  // Borders
  borderLight: 'rgba(0,0,0,0.06)',
  borderMedium: 'rgba(0,0,0,0.10)',
  borderStrong: 'rgba(0,0,0,0.20)',

  // Grays
  lightGray: '#f0f0f0',
  altGray: '#f7f7f7',
  medGray: '#6b6b6b',

  // Accent
  accent: 'rgb(85,127,177)',
  accentHover: 'rgb(70,110,158)',
  accentLight: 'rgba(85,127,177,0.06)',
  accentMed: 'rgba(85,127,177,0.12)',

  // Nav
  navBg: 'rgba(250,250,250,0.88)',

  // Hero overlays
  heroOverlay97: 'rgba(10,10,10,0.97)',
  heroOverlay92: 'rgba(10,10,10,0.92)',
  heroOverlay68: 'rgba(10,10,10,0.68)',
  heroOverlay22: 'rgba(10,10,10,0.22)',
  heroOverlay08: 'rgba(10,10,10,0.08)',

  // White opacity variants
  white92: 'rgba(255,255,255,0.92)',
  white88: 'rgba(255,255,255,0.88)',
  white65: 'rgba(255,255,255,0.65)',
  white52: 'rgba(255,255,255,0.52)',
  white38: 'rgba(255,255,255,0.38)',
  white32: 'rgba(255,255,255,0.32)',
  white25: 'rgba(255,255,255,0.25)',
  white22: 'rgba(255,255,255,0.22)',
  white20: 'rgba(255,255,255,0.20)',
  white15: 'rgba(255,255,255,0.15)',
  white14: 'rgba(255,255,255,0.14)',
  white08: 'rgba(255,255,255,0.08)',
  white07: 'rgba(255,255,255,0.07)',
  white05: 'rgba(255,255,255,0.05)',

  // Cream opacity variants (now neutral white for dark sections)
  cream92: 'rgba(255,255,255,0.92)',
  cream80: 'rgba(255,255,255,0.80)',
  cream65: 'rgba(255,255,255,0.65)',
  cream48: 'rgba(255,255,255,0.48)',
  cream35: 'rgba(255,255,255,0.35)',
  cream30: 'rgba(255,255,255,0.30)',
  cream22: 'rgba(255,255,255,0.22)',
  cream15: 'rgba(255,255,255,0.15)',
  cream12: 'rgba(255,255,255,0.12)',
  cream08: 'rgba(255,255,255,0.08)',
  cream05: 'rgba(255,255,255,0.05)',

  // Dark-section text
  darkWhite84: 'rgba(255,255,255,0.88)',
  darkWhite68: 'rgba(255,255,255,0.68)',
  darkWhite48: 'rgba(255,255,255,0.48)',
  darkWhite35: 'rgba(255,255,255,0.35)',
  darkWhite30: 'rgba(255,255,255,0.30)'
}
